<template>
	<div id="uppy"></div>
</template>

<script>
import { ACCOUNT_FILE_PUT } from '../../store/actions/accounts'

export default {
  name: 'UppyLoader',
  props: {
    accountId: {
      type: [String, Number]
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      uppy: null
    }
  },
  mounted () {
    this.injectCss()
    this.initUppy()
  },
  methods: {
    initUppy () {
      this.uppy = new window.UppyClass()
        .use(window.UppyDashboard, {
          target: '#uppy',
          inline: true
        })
        .use(window.UppyAwsS3, {
          endpoint: process.env.UPPY,
          shouldUseMultipart (file) {
            return file.size > 100 * 1024 * 1024
          },
          retryDelays: [0, 1000, 3000, 5000, 30000, 120000, 300000]
        })

      this.uppy.on('complete', () => {
        this.$emit('upload-success')
      })

      this.uppy.on('upload-success', (file, response) => {
        const fileData = {
          'file': {
            'name': file.name,
            'size': file.size,
            'type': file.type
          },
          's3ObjectLocation': response.body.key,
          ...this.data
        }

        this.$store.dispatch(ACCOUNT_FILE_PUT, fileData).then(response => {
          if (response.response === 'success') {
            this.$store.commit('modelUpdated', 'files')
          }
        })
      })
    },
    injectCss () {
      if (!document.getElementById('uppy-css')) {
        const link = document.createElement('link')
        link.id = 'uppy-css'
        link.rel = 'stylesheet'
        link.href = '/vendor/uppy.min.css'
        document.head.appendChild(link)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Elements/Uppy.vue